<ion-card class="section-card">
  <ion-card-header class="section-card-header">
    <div class="section-card-logo-wrap">
      @if (sectionLogo) {
        <ion-icon class="section-card-logo" [name]="sectionLogo" [style.color]="effectiveLogoColor"></ion-icon>
      } @else {
        <ion-chip class="section-card-nfk-chip">
          <span class="section-card-nfk-text">SI</span>
        </ion-chip>
      }
    </div>
    <div class="section-card-header-text">
      <ion-card-title class="section-card-title">{{ collapsableTitle | translate }}</ion-card-title>
      <ion-card-subtitle class="section-card-description">{{ description | translate }}</ion-card-subtitle>
    </div>
  </ion-card-header>

  <ion-card-content class="section-card-body">
    <ul class="section-card-subtitle-list">
      @for (sub of subTitles; track $index) {
        <li class="section-card-subtitle-item">
          <ion-icon [name]="sectionLogo || 'caret-forward-outline'" [style.color]="effectiveLogoColor" class="section-card-subtitle-icon"></ion-icon>
          <span class="section-card-subtitle-text">{{ sub | translate }}</span>
        </li>
      }
    </ul>
  </ion-card-content>

  <div class="section-card-footer">
    <ion-button color="secondary" class="section-card-btn"
      [routerLink]="['/home/all-reports', collapsableTitleId]"
      [queryParams]="{ title: collapsableTitle }">
      {{ 'Open reports' | translate }}
      <ion-icon name="arrow-forward-outline" slot="end"></ion-icon>
    </ion-button>

    <ion-icon name="bar-chart-outline" class="section-card-footer-icon" [style.color]="effectiveLogoColor"></ion-icon>
  </div>

</ion-card>
